import { render, staticRenderFns } from "./gameItems.vue?vue&type=template&id=2a26e681&"
import script from "./gameItems.vue?vue&type=script&lang=js&"
export * from "./gameItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports